import { Center, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { FONT } from "@styles/common";

export const CustomWrapper = styled(Center)`
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding: 14px;
    border: 1px solid ${({ theme }) => theme.COLOR.gray[400]};
    gap: 50px;
    border-radius: 16px;
`;

export const CustomCheckBox = styled(Center)`
    flex-direction: column;
`;

export const CustomDurationBox = styled(Center)`
    width: 48px;
    height: 48px;
    border: 1px solid ${({ theme }) => theme.COLOR.black};
    box-sizing: border-box;
    border-radius: 8px;
`;

export const CustomText = styled(Text)`
    ${FONT("cormorant", 20, 700, 1.5)}
`;
